import { readAppValue, subscribeRuntimeContext } from "../config/runtimeAccessor";
import { BAR_MENU } from "../utils/const";
import { normalizeCustomPermissions, processNodeAndPermissions } from "./com-helper";
import { customEntityRoutes } from "./commonHelper";

const CUSTOM_ENTITY_NODE = "Custom Entity";

const findCustomEntityNode = (node) => {
  if (!node?.child) return null;
  if (node.child[CUSTOM_ENTITY_NODE]) return node.child[CUSTOM_ENTITY_NODE];
  for (const child of Object.values(node.child)) {
    const found = findCustomEntityNode(child);
    if (found) return found;
  }
  return null;
};

// custom_permissions is keyed by module (edm, and any module added later),
// matching BAR_MENU's keys case-insensitively (edm ↔ EDM). BAR_MENU is built
// once at import time — usually before login/refresh has stored the user —
// so each module's "Custom Entity" children, and the aggregated
// permissions/childrenRoutes that accessibleMenus, getPath and
// checkRoutePermissions rely on, are rebuilt here whenever the stored user
// changes. Keys with no matching module (or no "Custom Entity" node) still
// grant access through permissionsFn; they just have no menu to fill.
export const syncCustomEntityMenu = () => {
  const customPermissions = normalizeCustomPermissions(readAppValue("user")?.custom_permissions);
  const keysByModule = Object.keys(customPermissions).reduce((acc, key) => {
    acc[key.toUpperCase()] = key;
    return acc;
  }, {});

  Object.entries(BAR_MENU).forEach(([moduleKey, moduleNode]) => {
    const customEntityNode = findCustomEntityNode(moduleNode);
    if (!customEntityNode) return;
    const permissionKey = keysByModule[moduleKey.toUpperCase()] ?? moduleKey.toLowerCase();
    customEntityNode.child = { ...customEntityRoutes(permissionKey) };
    processNodeAndPermissions(moduleNode);
  });
};

syncCustomEntityMenu();
subscribeRuntimeContext(syncCustomEntityMenu);
